export default __webpack_public_path__ + "static/media/entreprise.1df1d20a.png";